import { genericActions } from "../_helpers/ActionErrorWrapper";

import { LicensesTypeService } from "../_services/LicenseTypesService";
import { LicenseTypeMapper } from "../_mappers/LicenseTypeMapper";
import { LicenseTypeCollection } from "../_generics/LicenseTypeCollection";

export const LicenseTypesActions = {
    listLicenseTypes,

    //PRIVATE
    _listLicenseTypesSuccess: LicenseTypeCollection.actionListItemsSuccess,
};

function listLicenseTypes() {
    return async dispatch => {

        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const serverLicenseTypes = await LicensesTypeService.listLicenseTypes();
            dispatch(LicenseTypesActions._listLicenseTypesSuccess(
                LicenseTypeMapper.allServerToLocal(serverLicenseTypes),
            ));
        }
    };
}
